import React from 'react';
import { WebsiteImage } from 'components/TitleDescription';
import MarketoForm from '../MarketoForm';

const FixedDynamicMarketoForm = ({
  className,
  dataPosition,
  titleImage,
  formName,
  formType,
  shadow,
  marketoForm,
  title,
  showPrivacy,
  affixMobile,
  ...otherProps
}) => {
  return (
    <div className={className || ''} id="fixed-embed-marketo--form">
      {titleImage && (
        <WebsiteImage className="fixed-embed-marketo--title-image" src={titleImage?.fluid?.src} />
      )}
      <MarketoForm
        dataPosition={dataPosition}
        formName={formName}
        formType={formType}
        shadow={shadow}
        marketoForm={marketoForm}
        title={title}
        showPrivacy={showPrivacy}
        affixMobile={affixMobile}
        {...otherProps}
      />
    </div>
  );
};

export default FixedDynamicMarketoForm;
